import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import classnames from 'classnames';

import { useTranslation } from '@lt/localization';
import LTExtra from '../../../../components/LTExtra';
import ExtraPropTypes from '../../../Checkout/CheckoutRoutes/PackageCheckout/proptypes/extras';

import styles from './extraItems.module.css';

const ExtraItems = ({ items, isMobile, isHotelOnly }) => {
  const { t } = useTranslation();
  return (
    !isEmpty(items) &&
    !isHotelOnly && (
      <div
        className={classnames(styles.container, {
          [styles.containerMobile]: isMobile,
        })}
      >
        {isMobile ? (
          <h3 className={styles.title}>{t('hotel.extraItems')}</h3>
        ) : (
          <h2 className={styles.title}>{t('hotel.extraItems')}</h2>
        )}
        {items.map((ltExtra) => (
          <LTExtra
            className={styles.ltExtra}
            key={ltExtra.id}
            isMobile={isMobile}
            {...ltExtra}
          />
        ))}
      </div>
    )
  );
};

ExtraItems.defaultProps = {
  items: [],
  isMobile: false,
};

ExtraItems.propTypes = {
  items: ExtraPropTypes.items,
  isMobile: PropTypes.bool,
};

export default ExtraItems;
